import { LogLevel, log, warn } from "../utils/log";
import { _configuration } from "./configuration";

export const debug = {
    /**
     * Verify module configuration.
     *
     * Logs issues to console.
     *
     * @returns true if configuration is OK
     */
    verifyConfiguration: (): boolean =>
    {
        let numIssues = 0;

        log("Checking module configuration ...", LogLevel.NONE);

        const logIssue = (issue: string): void =>
        {
            warn(issue);
            numIssues++;
        };

        if (_configuration.clientConfig === undefined) {
            logIssue("Configuration missing clientConfig");
        }
        else if (_configuration.clientConfig.gameServerApi === undefined) {
            logIssue("Invalid clientConfig format - not a valid /getclientconfig/ response");
        }

        if (_configuration.loginResponse === undefined) {
            logIssue("Configuration missing loginResponse");
        }
        else if (_configuration.loginResponse.sid === undefined) {
            logIssue("Invalid loginResponse format - not a valid login response");
        }

        if (numIssues === 0) {
            log("... Configuration OK", LogLevel.NONE);
            return true;
        }

        log(`... Configuration is missing ${numIssues.toString()} element(s)`, LogLevel.NONE);
        return false;
    }
};